<template>
  <SportDiscoverTeamsOrganize sport="volleyball" />
</template>

<script>
import SportDiscoverTeamsOrganize from "@/routes/match_hub/shared/SportDiscoverTeamsOrganize.vue";

export default {
  name: "VolleyballOrganizeMatch",
  components: { SportDiscoverTeamsOrganize },
};
</script>
